import FnNumberFormat from '../../../../components/elements/FnInput/FnNumberFormat/index';
import React, { FC, memo, useCallback } from 'react';
import { ColorgateConfigurationFields } from '../../constants';

type TProps = {
  name: ColorgateConfigurationFields;
  value: number;
  setFieldValue: (field: ColorgateConfigurationFields, value: number) => void;
  title?: string;
  placeholder?: string;
  minValue?: number;
  maxValue?: number;
  suffix?: string;
  decimalScale?: number;
  allowNegative?: boolean;
};

const NumberFormatField: FC<TProps> = ({
  name,
  value,
  setFieldValue,
  title = '',
  placeholder = '',
  minValue = 0,
  maxValue = Number.MAX_SAFE_INTEGER,
  suffix = '',
  decimalScale = 0,
  allowNegative = false
}) => {
  const handleChange = useCallback(
    (optionValue: number) => {
      setFieldValue(name, optionValue);
    },
    [setFieldValue, name]
  );

  return (
    <FnNumberFormat
      defaultValue={value}
      title={title}
      placeholder={placeholder}
      onChange={handleChange}
      maxValue={maxValue}
      minValue={minValue}
      suffix={suffix}
      decimalScale={decimalScale}
      allowNegative={allowNegative}
    />
  );
};

export default memo(NumberFormatField);
